require('features/routing');
require('features/articleSearchBox');
require('libraries/appNexus');
require('./components/listingCounts');
require('./components/submitSearchHandler');
require('features/segment');
require('features/googleAnalytics4');

require('./components/eventTracking/googleAnalytics4EventsHandler');
require('./components/eventTracking/segmentEventsHandler');

// ugly injection for those components, after rebrand this will be
// removed once the listing for you section is moved to its own page
require('../../blog/components/listingsForYouSection');
require('../../blog/handlers/hyperlinkCardHandler');
require('../../blog/articlePage/components/asyncDependencies');
require('../../blog/articlePage/components/typeahead');

require('../../blog/components/shareaholicAsyncInject');

